import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';

const SperrDate = types.model('SperrDate', {
    id: types.identifierNumber,
    date: types.string,
    parking_field_id: types.maybeNull(types.number),
    fallback_parking_field_id: types.maybeNull(types.number),
});

const ParkingField = types
    .model('ParkingField', {
        id: types.identifierNumber,
        slug: types.string,
        name: types.string,
        capacity: types.number,
        issued_target: types.number,
        uses_external_qr: types.boolean,
        info_text: types.maybeNull(types.string),
        latitude: types.maybeNull(types.number),
        longitude: types.maybeNull(types.number),
        entrance: types.maybeNull(types.string),
        sperr_dates: types.optional(types.array(SperrDate), []),
    })
    .actions((self) => ({
        editField(edited) {
            // edited (PATCH response) omits relations — merge over the current snapshot
            // so the loaded sperr_dates aren't wiped.
            applySnapshot(self, { ...getSnapshot(self), ...edited });
        },
        addSperrDateLocal(sperr) {
            self.sperr_dates.push(sperr);
        },
        removeSperrDateLocal(sperrId) {
            const index = self.sperr_dates.findIndex((s) => s.id === sperrId);
            if (index !== -1) self.sperr_dates.splice(index, 1);
        },
    }));

export default ParkingField;
